import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateDraftEmployeeComplianceStepInput,
  PayrollUpdateDraftEmployeeComplianceGraphQLRequest,
  PayrollUpdateDraftEmployeeComplianceStepResponse,
} from '../types';

const payrollUpdateDraftEmployeeComplianceMutation = gql`
  mutation PayrollUpdateDraftEmployeeCompliance(
    $draftEmployeeId: Int!
    $input: PayrollUpdateDraftEmployeeComplianceStepInput!
  ) {
    payrollUpdateDraftEmployeeCompliance(draftEmployeeId: $draftEmployeeId, input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const updateDraftEmployeeComplianceStep = (payload: {
  draftEmployeeId: number;
  input: PayrollUpdateDraftEmployeeComplianceStepInput;
}) => {
  return graphQLApi<
    PayrollUpdateDraftEmployeeComplianceStepResponse,
    PayrollUpdateDraftEmployeeComplianceGraphQLRequest
  >({
    query: payrollUpdateDraftEmployeeComplianceMutation,
    queryVariables: payload,
  });
};
